import { buildPanelItem } from "../helpers/buildPanelItem";
import { Label } from "../components/Label";

export const captureInformationGeoPanel = [
  buildPanelItem(
    "1",
    Label({ label: "latitude", type: "string" }),
    "The approximate latitude where the capture took place.",
  ),
  buildPanelItem(
    "2",
    Label({ label: "longitude", type: "string" }),
    "The approximate longitude where the capture took place.",
  ),
  buildPanelItem(
    "3",
    Label({ label: "city", type: "string" }),
    "The estimated city where the capture took place.",
  ),
  buildPanelItem(
    "4",
    Label({ label: "country", type: "string" }),
    "The estimated country where the capture took place.",
  ),
];
